import { VariableSizeList as List } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import React from "react";
import OneRow from "./OneRow";
import { useEffect } from "react";

const ScrollSubtitles = ({ list, subNum, seekToVideo, activeSubtitleId }) => {
  const [activeList, setActiveList] = React.useState(false);
  const [enableScroll, setenableScroll] = React.useState(true);
  const listRef = React.useRef();

  const calculateSize = (length, windowWidth) => {
    if (length < 30) {
      if (windowWidth < 300) return 40;
      else return 30;
    } else if (length < 80) {
      if (windowWidth < 300) return 70;
      else return 50;
    } else if (length < 200) {
      if (windowWidth < 300) return 110;
      else return 80;
    } else if (length < 400) {
      if (windowWidth < 300) return 135;
      else return 90;
    } else {
      if (windowWidth < 300) return 150;
      else return 120;
    }
  };

  useEffect(() => {
    if (list.length > 0 && activeList && enableScroll) {
      listRef.current.scrollToItem(activeSubtitleId, "center");
    }
  }, [activeSubtitleId]);

  useEffect(() => {
    setTimeout(() => {
      setActiveList(true);
    }, 3000);
  }, []);

  return (
    <AutoSizer
      onMouseEnter={() => {
        setenableScroll(false);
      }}
      onMouseLeave={() => {
        setenableScroll(true);
      }}
    >
      {({ height, width }) => (
        <List
          height={height}
          itemCount={list.length}
          itemSize={(index) => {
            return calculateSize(list[index]["text"].length, width);
          }}
          width={width}
          ref={listRef}
        >
          {({ index, style }) => (
            <div
              style={{
                ...style,
                ...{
                  backgroundColor:
                    activeSubtitleId == index + 1 ? "#5CB338" : null,
                  color: activeSubtitleId == index + 1 ? "#000000" : null,
                },
              }}
            >
              <OneRow
                subNum={subNum}
                index={index}
                sub={list[index]}
                width={width}
                seekToVideo={seekToVideo}
              />
            </div>
          )}
        </List>
      )}
    </AutoSizer>
  );
};
export default ScrollSubtitles;
